const isUserRecord = (value) =>
  Boolean(value)
  && typeof value === 'object'
  && !Array.isArray(value)
  && (value.full_name || value.first_name || value.last_name || value.email || value.profile_image || value.username);

/** User object from a list row, including `{ full_name, email, profile_image }`. */
export const pickUser = (...candidates) => {
  for (const candidate of candidates) {
    if (typeof candidate === 'string' && candidate.trim()) return { full_name: candidate.trim() };
    if (isUserRecord(candidate)) return candidate;
  }
  return null;
};

export const userImageUrl = (user) => {
  if (!user || typeof user !== 'object') return '';
  const image = user.profile_image || user.picture || user.avatar || user.image || '';
  return typeof image === 'string' ? image.trim() : '';
};

/**
 * Display name from user object (full_name, then first_name + last_name).
 */
export const formatUserName = (user) => {
  if (!user || typeof user !== 'object') return '';
  if (typeof user.full_name === 'string' && user.full_name.trim()) return user.full_name.trim();
  return `${user.first_name || ''} ${user.last_name || ''}`.trim();
};

export const formatUserNameOrFallback = (user, fallback = '—') => {
  const name = formatUserName(user);
  if (name) return name;
  if (user?.username) return user.username;
  if (user?.name) return user.name;
  if (user?.email) return user.email;
  if (typeof user === 'string') return user;
  return fallback;
};
